import EnterIcon from './component'

export default EnterIcon
